import React, { useEffect, useRef, useState } from 'react';
import { useMedia, useClickAway } from 'react-use';
import { addMultipleToCart } from 'ck-utils';
import classnames from 'classnames';
import { Typography, Icon, Button } from 'ck-ui';
import PropTypes from 'prop-types';
import { ProductHit } from '../ProductListingPage/productList/ProductHit/ProductHit';
import styles from './WishlistCollection.module.scss';

const WishlistCollection = ({
  currentList, ProductHits, deleteProductFromWishList, goBack, deleteWishList, loadMore, loading, indexName
}) => {
  const [showDropdown, setShowDropDown] = useState(false);
  const dropDownRef = useRef();
  const isMobile = useMedia('(max-width: 767px)');
  const pageSize = ProductHits.length;
  const currentListSize = currentList.products.length;

  useEffect(() => {
    if (pageSize === 0) return;
    window.theme.initCollectionAddToCart();
  }, [pageSize]);

  useClickAway(dropDownRef, () => setShowDropDown(false));

  const handleDeleteWishList = () => {
    deleteWishList(currentList.lid);
    goBack();
  };

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <div className="is-flex-centered">
          <Icon name="arrow-left" className={styles.back} onClick={goBack} />
          <Typography
            title={currentList.lname}
            uppercase
            display="inline"
            renderAs="h2"
            variant="heading7"
          >
            {currentList.lname} {` (${pageSize} of ${currentListSize})`}
          </Typography>
        </div>
        <div className={styles.menu} tabIndex={0} role="button" onClick={() => setShowDropDown(!showDropdown)}>
          <ol className={styles.ol}>
            <li className={styles.dot} />
            <li className={styles.dot} />
            <li className={styles.dot} />
          </ol>
          <div ref={dropDownRef} className={classnames(styles.popup, { 'is-hidden': !showDropdown })}>
            <Typography
              renderAs="a"
              capitalize
              variant="body"
              className={styles.link}
              onClick={
                () => addMultipleToCart(currentList.products.slice(0, pageSize).map((product) => ({
                  id: product.variantId,
                  quantity: 1,
                })))}
            >
              Add All To Cart
            </Typography>
            <Typography renderAs="a" className={classnames(styles.link, 'mt-1')} onClick={handleDeleteWishList}>Delete Wishlist</Typography>
          </div>
        </div>
      </div>
      <div className="columns is-multiline is-mobile is-variable is-1-mobile">
        {pageSize ? (ProductHits.map((hit) => (
          <div key={hit.id} className="column is-half-mobile is-half-tablet is-one-quarter-desktop">
            <ProductHit
              hit={hit}
              isMobile={isMobile}
              indexName={indexName}
              showWishlistDeleteBtn
              wishlistHasLoaded
              listName="wishlist"
              canClickThrough
              handleDeleteFromWishlist={() => {
                const { variantId, handle, id } = currentList.products.find((ele) => ele.id === `${hit.id}`);
                deleteProductFromWishList({ lid: currentList.lid, variantId, handle, id });
              }}
            />
          </div>
        ))
        ) : (
          <Typography className={styles.center} variant="heading5">This Wishlist is empty!!!</Typography>
        )}
      </div>
      {pageSize < currentListSize && (
        <div className="has-text-centered">
          <Button
            renderAs="a"
            onClick={() => loadMore()}
            size="large"
            title="Load More"
            loading={loading}
          >
            Load More
          </Button>
        </div>
      )}
    </div>
  );
};

WishlistCollection.propTypes = {
  currentList: PropTypes.object.isRequired,
  ProductHits: PropTypes.array.isRequired,
  deleteProductFromWishList: PropTypes.func,
  deleteWishList: PropTypes.func,
  goBack: PropTypes.func,
  loadMore: PropTypes.func,
  loading: PropTypes.bool.isRequired,
  indexName: PropTypes.string.isRequired,
};

export { WishlistCollection };
